import { APColumn, APImage, APSizedBox, APText } from "ap-components";

export default function LoadingState() {
    return (
        <APColumn style={{ padding: "31px" }} mainAxisSize="max" mainAxisAlignment="center" crossAxisAlignment="center">
            <APText>Please do not press Back or Refresh button until the whole process is completed</APText>
            <APSizedBox height="32px" />
            <APImage src="/img/ic_loader.svg" />
            <APSizedBox height="32px" />
            <APText>You are being redirected...</APText>
        </APColumn>
    )
}